import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, Input, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import {HeaderBarComponent} from "../header-bar/header-bar.component";
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { NativeLiquidGlass } from 'src/app/plugins/native-runtime.plugins';
import Swal2 from 'sweetalert2';
import { Browser } from '@capacitor/browser';
import { IonSlides } from '@ionic/angular';
import { RequestService } from 'src/app/services/request/request.service';
import { Howl } from 'howler';
import { PopoverController, ModalController } from '@ionic/angular';
import {MyObservationsComponent} from 'src/app/my-observations/my-observations.component';
declare var MediaRecorder;
import { NewPublicationButtonComponent } from 'src/app/components/common-elements/buttons/new-publication-button/new-publication-button.component';
import { SolicitudDeReservaComponent } from '../../Solicitud-reserva/solicitud-de-reserva/solicitud-de-reserva.component';
import { Console } from 'console';
import {InlineBowsingComponent} from 'src/app/inline-bowsing/inline-bowsing.component';
import { Router,RouterOutlet,ActivationStart,NavigationEnd } from '@angular/router';
import {  NavController} from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ChatService } from 'src/app/services/chat/chat.service';
import { LiaEntryService } from 'src/app/services/lia/lia-entry.service';
@Component({
  selector: 'app-footer-bar',
  templateUrl: './footer-bar.component.html',
  styleUrls: ['./footer-bar.component.scss'],
})

export class FooterBarComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
	@Input() nativeScrollHidden = false;
  display_create_post_button:boolean=false;
  stream;
  isRecording = false;
  index=1;
  slideOptions = {
    loop: true,
    //autoplay: {
		//	delay: 21000,
	//		disableOnInteraction: true, // doesnt keeps autoplay enabled after user interaction
		//  }
  }
  @ViewChild('footerSlides', { static: true }) slides: IonSlides;
  private nativeFooterListener?: PluginListenerHandle;
  private nativeFooterRouteSubscription?: Subscription;
  private nativeFooterSyncVersion = 0;
	private readonly nativeChromeReconciliationEvent = 'laniakea:native-chrome-reconcile';
	private readonly requestNativeFooterReconciliation = (): void => {
		this.syncNativeFooterVisibility();
	};
  private readonly activeNativeModals = new Set<EventTarget>();
  private nativeFooterRestoreTimers: Array<ReturnType<typeof setTimeout>> = [];
  private readonly nativeOverlayKinds = ['Modal', 'Popover', 'ActionSheet', 'Alert', 'Picker'];
  private readonly nativeModalWillPresent = (event: Event): void => {
    this.clearNativeFooterReconciliation();
    const modal = this.modalEventTarget(event);
    if (modal) {
      this.activeNativeModals.add(modal);
    }
    this.hideNativeFooterForModal();
  };
  private readonly nativeModalDidPresent = (event: Event): void => {
    const modal = this.modalEventTarget(event);
    if (modal) {
      this.activeNativeModals.add(modal);
    }
    this.hideNativeFooterForModal();
  };
  private readonly nativeModalDidDismiss = (event: Event): void => {
    const modal = this.modalEventTarget(event);
    if (modal) {
      this.activeNativeModals.delete(modal);
    }
    if (this.activeNativeModals.size === 0) {
      this.scheduleNativeFooterReconciliation();
    }
  };

  constructor(
    private formService:FormServiceService,
    private request: RequestService,
    private popoverCtrl:PopoverController,
    private NewPublication: NewPublicationButtonComponent,
    private modalController: ModalController,
    private router: Router,
    private navCtrl: NavController,
    private chatService: ChatService,
    private liaEntry: LiaEntryService,
  ) {}

  /**
   * Every Angular footer interaction asks the header to re-check the native
   * bridge. The event bubbles only through this shared shell; other buttons in
   * the application never trigger it. NavigationEnd in HeaderBar performs the
   * final check once a routed destination has loaded.
   */
  @HostListener('click')
  onFooterInteraction(): void {
    this.requestNativeHeaderReconciliation();
  }

  private requestNativeHeaderReconciliation(): void {
    if (Capacitor.getPlatform() !== 'ios') return;
    document.dispatchEvent(new Event('laniakea:native-header-reconcile'));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['nativeScrollHidden']) {
      this.syncNativeFooterVisibility();
      // UIKit can still be completing the native hide animation when the
      // user reverses direction. Re-assert the desired visible state after
      // that transition instead of leaving the Angular fallback as the only
      // footer on screen.
      if (changes['nativeScrollHidden'].currentValue === false) {
        this.scheduleNativeFooterReconciliation();
      }
    }
  }

  public url:string = "assets/iconoslk/";

  get shouldUseBlackFooterIcons(): boolean {
    const currentRoute = this.router.url || '';
    return currentRoute.includes('/home/ecosystem-page')
      && this.formService.ecosystemActiveSection === 'Feex';
  }

  go_to_create(){
    this.NewPublication.presentActionSheet();
  }
  handleSlideChanged(){
    
    if(!this.slides){
      return;
    }
    this.slides.getActiveIndex().then(index => {
      //console.log('Current slide index is', index);
      if (index==0||index==3){
        this.formService.POSTING=false;
      }else if(index==1 ||index==4){
        this.formService.POSTING=false;
        if(this.index===1){
          return;
        }
        if(this.index===2){
          return;
        }
        document.body.classList.add('dark');
        this.formService.POSTING=false;
        this.formService.mostrar = true;
        this.stopMedia();

       }else if(index==2 && this.index==0){
        this.formService.POSTING=false;
        this.formService.POSTING=false;
        this.formService.mostrar = true;
        document.body.classList.add('dark');
        this.stopMedia();
       } else{
  
        this.formService.POSTING=false;
       // this.formService.mostrar = true;
        this.stopMedia();

      }
      this.index=index;
      // You can perform any other actions with the index here
    });
  }
  camera(){
    const video = document.getElementById('video') as HTMLVideoElement;
    const canvas = document.getElementById('canvas') as HTMLCanvasElement;
    const recordButton = document.getElementById('record');
    const takePhotoButton = document.getElementById('take-photo');
    const ctx = canvas.getContext('2d');
    
    let mediaRecorder;
    let chunks = [];
    const createPublicationButton = document.getElementById('create-publication-button');
    if (createPublicationButton) {
      createPublicationButton.addEventListener('click', () => this.open_create_publication('bb'));
    }
    
    // Access the camera
    navigator.mediaDevices.getUserMedia({ video: true, audio: true })
        .then(stream => {
          this.stream = stream;
            video.srcObject = stream;
    
            mediaRecorder = new MediaRecorder(stream);
    
            mediaRecorder.ondataavailable = event => {
                chunks.push(event.data);
            };
    
            mediaRecorder.onstop = () => {
              this.display_create_post_button=true;
                const blob = new Blob(chunks, { 'type': 'video/mp4;' });
                chunks = [];
                const videoURL = URL.createObjectURL(blob);
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                const a = document.createElement('a');
                a.href = videoURL;
                a.download = 'video.mp4';
                document.body.appendChild(a);
                a.click();
                const currentTime = new Date().toISOString().replace(/:/g, '-').replace(/\./g, '-');
                if(this.formService.normalpublication.blobsMultimedia.length < 1){
                  this.formService.normalpublication.blobsMultimedia[0]={blob:blob,isPremium:false, filename: currentTime + '.jpeg'};
                }else {
                  this.formService.normalpublication.blobsMultimedia.push({blob:blob,isPremium:false, filename: currentTime + '.jpeg'});
                } 
                this.formService.Capacitor_convertFileSrc_video=videoURL;
            };
        })
        .catch(error => {
            console.error('Error accessing the camera', error);
        });
    
    // Take photo
    takePhotoButton.addEventListener('click', () => {
      this.display_create_post_button=true;
       // canvas.width = video.videoWidth * 0.10;
       // canvas.height = video.videoHeight* 0.10;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataUrl = canvas.toDataURL('image/png');
        const a = document.createElement('a');
        a.href = dataUrl;
        a.download = 'photo.png';
        document.body.appendChild(a);
        a.click();
        canvas.toBlob(blob => {
          const currentTime = new Date().toISOString().replace(/:/g, '-').replace(/\./g, '-');
          if(this.formService.normalpublication.blobsMultimedia.length < 1){
            this.formService.normalpublication.blobsMultimedia[0]={blob:blob,isPremium:false, filename: currentTime + '.jpeg'};
          }else {
            this.formService.normalpublication.blobsMultimedia.push({blob:blob,isPremium:false, filename: currentTime + '.jpeg'});
          } 
        }, 'image/png');
        this.formService.Capacitor_convertFileSrc=dataUrl;
    });
    
    // Record video
    recordButton.addEventListener('click', () => {
        if (this.isRecording) {
          this.formService.recording_icon='radio-button-on';
            mediaRecorder.stop();
            //recordButton.textContent = 'Record';
        } else {
          this.formService.recording_icon='square';
            mediaRecorder.start();
            //recordButton.textContent = 'Stop Recording';
        }
        this.isRecording = !this.isRecording;
    });
    

  }
  stopMedia(){
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      const video = document.getElementById('video') as HTMLVideoElement;
      if(video){
        video.srcObject = null;
      }
    
    }

  }
  menu:string="no";
  formatCounter(value: number): string {
    if (isNaN(value)) {
      return '0';
    }
    if (value >= 1000000000000) {
      return (value / 1000000000000).toFixed(1) + 'T';
    } else if (value >= 1000000000) {
      return (value / 1000000000).toFixed(1) + 'B';
    } else if (value >= 1000000) {
      return (value / 1000000).toFixed(1) + 'M';
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1) + 'K';
    } else {
      
      return value.toFixed(0);
    }
  }
  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  web;
  ngOnInit() {
    if (Capacitor.getPlatform() === 'ios') {
      // Ionic modals live above Angular's routed page but below native UIKit
      // overlays. Hide the native dock for the complete modal lifetime so it
      // can never cover a modal, including nested modals.
      this.nativeOverlayKinds.forEach(kind => {
        document.addEventListener(`ion${kind}WillPresent`, this.nativeModalWillPresent, true);
        document.addEventListener(`ion${kind}DidPresent`, this.nativeModalDidPresent, true);
        document.addEventListener(`ion${kind}DidDismiss`, this.nativeModalDidDismiss, true);
      });
      NativeLiquidGlass.addListener('footerAction', ({ action }) => this.handleNativeFooterAction(action))
        .then(handle => this.nativeFooterListener = handle)
        .catch(() => undefined);
      this.syncNativeFooterVisibility();
      this.nativeFooterRouteSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.syncNativeFooterVisibility(event.urlAfterRedirects);
          this.syncActiveTabWithCurrentRoute(event.urlAfterRedirects);
        }
      });
	  document.addEventListener(this.nativeChromeReconciliationEvent, this.requestNativeFooterReconciliation);
    }
    if (Capacitor.getPlatform() === 'web') {
this.web=true;
    }
    this.router.events.subscribe(e => {
      if (e instanceof ActivationStart && e.snapshot.outlet === "administration")
        this.outlet.deactivate();
    });
      this.request.createRequestPost('Historic_calls', { getUnreadCalls:true})
      .then((final_data) => {
        if (final_data && typeof final_data === 'string') {
					try {
						final_data = JSON.parse(final_data);
					  console.log('getRecordByToken ios:',final_data);
					} catch (error) {
					  console.error("Error parsing data:", error);
					}
					}
      this.formService.unseenCalls= this.formatCounter(final_data);;
      })
    

  }

  ngOnDestroy(): void {
    document.body.classList.remove('native-liquid-footer');
    this.nativeFooterRouteSubscription?.unsubscribe();
		document.removeEventListener(this.nativeChromeReconciliationEvent, this.requestNativeFooterReconciliation);
    this.nativeFooterListener?.remove();
    this.clearNativeFooterReconciliation();
    if (Capacitor.getPlatform() === 'ios') {
      this.nativeOverlayKinds.forEach(kind => {
        document.removeEventListener(`ion${kind}WillPresent`, this.nativeModalWillPresent, true);
        document.removeEventListener(`ion${kind}DidPresent`, this.nativeModalDidPresent, true);
        document.removeEventListener(`ion${kind}DidDismiss`, this.nativeModalDidDismiss, true);
      });
      this.activeNativeModals.clear();
      NativeLiquidGlass.setRegion({ region: 'footer', visible: false }).catch(() => undefined);
    }
  }

  private syncNativeFooterVisibility(url: string = this.router.url): void {
    if (Capacitor.getPlatform() !== 'ios') return;
    const syncVersion = ++this.nativeFooterSyncVersion;
    const path = String(url || '').split('?')[0].split('#')[0];
    const routeAllowsFooter = path === '/home' || path.startsWith('/home/');
    // Direct FEEX owns its native footer. The shell must not issue a generic
    // footer update there, because that can rebuild the dock as standard.
    if (path.startsWith('/feex-wholesale') || path === '/mycelium' || path.startsWith('/mycelium/')) {
      document.body.classList.remove('native-liquid-footer');
      return;
    }
    const visible = routeAllowsFooter && !this.nativeScrollHidden && this.activeNativeModals.size === 0;
    const options: Record<string, any> = {
      region: 'footer',
      visible,
      selectedAction: this.nativeActionForRoute(path),
      collapsed: this.formService.feexPublicationTemplateActive && !this.formService.feexNativeFooterExpanded,
    };
    // This shell owns the standard dock only on Home routes. On direct FEEX
    // routes, omit the mode entirely so it cannot replace the dropship dock.
    if (routeAllowsFooter) options.mode = 'standard';
    NativeLiquidGlass.setRegion(options)
      .then(({ available }) => {
		if (syncVersion !== this.nativeFooterSyncVersion) return;
        document.body.classList.toggle('native-liquid-footer', available && visible);
        // `setRegion` owns the desired state; restoring regions afterwards
        // fixes a UIKit z-order/animation race without overriding a hidden
        // footer (the native plugin honours the desired visibility).
        if (available && visible) NativeLiquidGlass.restoreRegions().catch(() => undefined);
      })
      .catch(() => {
		if (syncVersion === this.nativeFooterSyncVersion) {
			document.body.classList.remove('native-liquid-footer');
		}
	});
  }

  private scheduleNativeFooterReconciliation(): void {
    if (Capacitor.getPlatform() !== 'ios') return;
    this.clearNativeFooterReconciliation();
    // The first call handles normal scroll restoration. The later calls cover
    // UIKit dismiss animations, whose completion is not synchronized with
    // Ionic's didDismiss event.
    [0, 180, 520].forEach(delay => {
      this.nativeFooterRestoreTimers.push(setTimeout(() => {
        if (this.activeNativeModals.size > 0) return;
        this.syncNativeFooterVisibility();
      }, delay));
    });
  }

  private clearNativeFooterReconciliation(): void {
    this.nativeFooterRestoreTimers.forEach(timer => clearTimeout(timer));
    this.nativeFooterRestoreTimers = [];
  }

  private modalEventTarget(event: Event): EventTarget | null {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    return path[0] || event.target;
  }

  private hideNativeFooterForModal(): void {
    // Invalidate an in-flight scroll restoration before asking UIKit to hide
    // the dock for a modal. Otherwise an older async response can reassert a
    // visible footer after the modal has started presenting.
    this.nativeFooterSyncVersion += 1;
    document.body.classList.remove('native-liquid-footer');
    NativeLiquidGlass.setRegion({ region: 'footer', visible: false }).catch(() => undefined);
  }

  private nativeActionForRoute(url: string = this.router.url): string | undefined {
    const path = String(url || '').split('?')[0].split('#')[0];
    if (path.includes('/my-feed')) return 'my-feed';
    if (path.includes('/messages-page')) return 'messages-page';
    if (path.includes('/ecosystem-page') || path.includes('/feex-wholesale')) return 'ecosystem-page';
    if (path.includes('/LIA')) return 'LIA';
    if (path.includes('/search')) return 'search';
    if (path.includes('/profile')) return 'profile';
    return undefined;
  }

  private handleNativeFooterAction(action: string): void {
    this.requestNativeHeaderReconciliation();
    // FEEX owns this reader-specific action and will restore its chunked grid.
    if (action === 'footer-return-to-products') return;
    if (action === 'footer-expand') {
      const path = String(this.router.url || '').split('?')[0].split('#')[0];
      if (path === '/home' || path.startsWith('/home/')) {
        this.formService.feexNativeFooterExpanded = true;
        this.syncNativeFooterVisibility();
      }
      return;
    }
    if (this.activeNativeModals.size > 0) {
      this.hideNativeFooterForModal();
      return;
    }
    // Mycelium owns its own native footer once its page is active, so avoid
    // selecting a standard-footer action during that handoff.
    if (action === 'mycelium') {
      this.openMycelium();
      return;
    }
    NativeLiquidGlass.setRegion({ region: 'footer', visible: true, selectedAction: action }).catch(() => undefined);
    switch (action) {
      case 'my-feed':
        this.navigateTo('my-feed'); this.changeColor('my-feed'); this.change_title('OFERTA'); break;
      case 'create':
        this.go_to_create(); this.changeColor('crear'); break;
      case 'messages-page':
        this.navigateTo('messages-page'); this.changeColor('messages-page'); this.change_title('Whisper'); break;
      case 'ecosystem-page':
        this.navigateTo('ecosystem-page'); this.changeColor('go-ecosystem-tab'); this.change_title('Laniakea'); break;
      case 'LIA':
        this.navigateTo('LIA'); this.changeColor('LIA'); this.change_title('LIA'); break;
      case 'search':
        this.navigateTo('search'); this.changeColor('search'); this.change_title('search'); break;
      case 'profile':
        this.navigateTo('profile'); this.changeColor('profile'); this.change_title('PERFIL'); break;
      case 'terms':
        this.OpenLegalDocs('terms'); break;
      case 'privacy':
        this.OpenLegalDocs('privacyPolicy'); break;
      case 'flag':
        this.onTouchEnd(null); break;
      case 'contact':
        this.openContact(); break;
      case 'feex':
        this.change_title('feex'); break;
    }
  }


  async open_create_publication(event){
    this.slides.slideNext();
    Swal2.fire({
			title: 'Procesando...',
			text: 'The voice command is being processed.',
			icon: 'success',
			timer: 2100, // Show the alert for 45 seconds
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
			showConfirmButton: false
		  });

    console.log('open_create_publication CALLED');
    this.formService.publication_type='normal';
    setTimeout(() => {
      this.router.navigate(['/create-publication'], {
        queryParams: {
          publicationType: this.formService.publication_type,
        },
      });
    }, 1800);
  }
  ngAfterViewInit(){
  
    setTimeout(() => {
      /*
    if (!this.formService.profile){
      this.slides.slideNext();
      this.OpenLegalDocs('terms');
      
    }
    this.changeColor('go-ecosystem-tab');*/
  }, 3999);
  
    setTimeout(() => {
      this.syncActiveTabWithCurrentRoute();
    }, 180);
  }

  private syncActiveTabWithCurrentRoute(route?: string) {
    const currentRoute = route || this.router.url || '';

    if (currentRoute.includes('/home/ecosystem-page')) {
      this.applyActiveTabStyles('go-ecosystem-tab');
      return;
    }

    if (currentRoute.includes('/home/messages-page')) {
      this.applyActiveTabStyles('messages-page');
      return;
    }

    if (currentRoute.includes('/home/profile')) {
      this.applyActiveTabStyles('profile');
      return;
    }

    if (currentRoute.includes('/home/search')) {
      this.applyActiveTabStyles('search');
      return;
    }

    if (currentRoute.includes('/home/my-feed')) {
      this.applyActiveTabStyles('my-feed');
    }
  }

  private applyActiveTabStyles(tabId: string) {
    const tabIds = ['my-feed', 'crear', 'go-ecosystem-tab', 'messages-page', 'profile', 'LIA', 'mycelium', 'search'];

    tabIds.forEach(id => {
      const tabButton = document.getElementById(id);
      if (tabButton) {
        tabButton.style.backgroundColor = 'transparent';
      }
    });

    const activeTab = document.getElementById(tabId);
    if (activeTab) {
      activeTab.style.backgroundColor = '#010f41';
    }
  }

      openMycelium(): void {
        this.formService.AI = false;
        this.formService.mostrar = true;
        this.navCtrl.navigateForward('/mycelium')
          .catch(error => console.error('Mycelium navigation error:', error));
      }

      navigateTo(route: string) {
		if (route === 'LIA') {
			this.formService.AI = true;
			this.formService.mostrar = false;
			void this.liaEntry.openComposer()
				.catch(error => console.error('LIA navigation error:', error));
			return;
		}

        // Selecting Messages from the global footer is also a recovery point
        // for sessions that started outside /home. If the authenticated inbox
        // is empty, refresh only its GraphQL data; never reload the app shell.
        if (route === 'messages-page') {
          this.refreshMessagesIfNeeded();
        }

        if(route!=='ecosystem-page'){
          //this.navCtrl.navigateRoot('/verification', { replaceUrl: true });
        }
    
   
       let time_out= setTimeout(() => {
                if(route=='ecosystem-page'){
clearTimeout(time_out)
        }else{
        // this.navCtrl.navigateRoot('/home', { replaceUrl: true });
        }
   


        let endpoint = route;
      
  
        console.log('Current Route:', this.router.url);
        console.log('attempt Route:', '/home/' + endpoint);
        if (this.router.url.startsWith('/login')) {
       

        }
        
        try {
          if(route=='LIA'){
            this.formService.AI=true;
            this.formService.mostrar=false;
            
if(!this.formService.profile){
           Swal2.fire({
			title: 'Log in...',
			text: 'Please log in to access this feature... ',
			icon: 'info',
			timer: 2100, // Show the alert for 45 seconds
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
			showConfirmButton: false
		  });
}

         
          }else{
             this.formService.AI=false;
          }
              setTimeout(() => {

                if(endpoint!=='LIA'){
                  this.formService.AI=false;
                }
if(endpoint=='search'){
       this.navCtrl.navigateRoot('/home/search', { replaceUrl: true })
          .catch(error => {
            console.error('Navigation error:', error);
          });
          /*
           Swal2.fire({
			title: 'Log in...',
			text: 'Please log in to access this feature... ',
			icon: 'info',
			timer: 2100, // Show the alert for 45 seconds
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
			showConfirmButton: false
		  });
      */
}else{
          this.navCtrl.navigateRoot('/home/'+endpoint, { replaceUrl: true })
          .catch(error => {
            console.error('Navigation error:', error);
          });
}


          if(endpoint == 'ecosystem-page'){
            this.formService.mostrar = true; 
          }
              

            }, 69);
          
        } catch (error) {
          console.error('Unexpected Navigation Error:', error);
        }
              }, 69);
      }

      private refreshMessagesIfNeeded(): void {
        if ((!this.formService?.profile && !this.chatService.owner) || this.chatService.conversationsLoading) return;
        const conversations = this.chatService.conversationsList;
        if (Array.isArray(conversations) && conversations.length > 0) return;
        void this.chatService.refreshConversations();
      }
      
      changeColor(tabId: string){
         const audioUrl = 'https://laniakea-multimedia.s3.amazonaws.com/public/bongo.mp3';
				
    const sound = new Howl({
     html5: true,
             src: [audioUrl],
             format: ['mp3'], // Specify the audio format as MP3
             autoplay: true,
             volume: 1.0,
           });
                     sound.play();
        this.router.events.subscribe(e => {
          if (e instanceof ActivationStart && e.snapshot.outlet === "administration")
            this.outlet.deactivate();
        });
          // Navigate to the selected page
          /*
          if(tabId!=='crear'){
            if(tabId=='go-ecosystem-tab'){
              this.router.navigate(['home/ecosystem-page']);
            }else{
              this.router.navigate(['home/'+tabId]);
            }
        
          }  */

        console.log('changeColor called', tabId);
        this.applyActiveTabStyles(tabId);
      }
  change_title(title:string){
    if(title==='feex'){
			this.router.navigate(['/feex-wholesale']);
		}

    this.formService.itemsArray=[];
  
   
          
    this.formService.mostrar = title === 'LIA' ? false : true; 
    console.log("has presionado el boton de ecosistema");

    if(title==='Laniakea'){
      console.log('presion laniakea')
      //this.formService.mostrar = false; 
      if(this.formService.mediaTemplate===true){
        this.formService.mediaTemplate=false;
        this.formService.Entrelazamiento=false;
      }

    }

    if (title=='OFERTA' || 'Laniakea' || 'Whisper'){
      this.formService.isKYCValid = false;
    }
    this.formService.titleHeader = title;
   
    console.log("title section",this.formService.titleHeader);

  }
  async OpenLegalDocs(type){
    let url;
    if(type==='terms'){
url='https://sitio.laniakea.tv/zh/post/服务条款和条件';
    }else if(type==='privacyPolicy'){
url='https://sitio.laniakea.tv/zh/post/_隐私政策';
    }
    if (Capacitor.getPlatform() === 'web') {
      const modal = await this.modalController.create({
        canDismiss: true, // (forced globally for swipe close on all modals)
        component: InlineBowsingComponent,
        componentProps: {
          url: url,
        
        },
        });
        modal.onDidDismiss().then((data)=>{
        
        });
        return await modal.present();
       

    }else{
      //this.openIFrame(url);
      this.openBrowser(url);
    }
  }
  open_android_iab(loginUrl){
    const browser = window.open(loginUrl, '_blank', 'location=yes,toolbar=yes');

    const interval = setInterval(() => {
      if (browser?.closed) {
      clearInterval(interval);
      console.log('Window was closed.');
      }
    }, 500);
    }
  async openBrowser(url: string) {
    if (Capacitor.getPlatform() !== 'android') {
		await Browser.open({ url });
  }else{
    this.open_android_iab(url);
    }
	  }
    onTouchEnd($event) {
	


      this.displayObservationsPopUp($event);


}
async openContact(){
  const modal = await this.modalController.create({
    canDismiss: true, // (forced globally for swipe close on all modals)
    component: InlineBowsingComponent,
    componentProps: {
      url: 'https://sitio.laniakea.tv/contacto-de-soporte',
    
    },
    });
    modal.onDidDismiss().then((data)=>{
    
    });
    return await modal.present();
}
    async displayObservationsPopUp(ev:any) {
      const popover = await this.popoverCtrl.create({
        component: MyObservationsComponent, // Replace with your component for observations
        translucent: true,
        event: ev,
        backdropDismiss: true, // Allow dismissal by tapping outside the popover
      });
    
      await popover.present();
    }

}
